module.exports = __webpack_public_path__ + "static/media/ImgNovedades220908.dea93f2d.jpg";